export default __webpack_public_path__ + "static/drone-compressed-165470c331da15d32d516c3440f4d38a.mp4";